import Icon from '../../components/Icon.vue'

Icon.register({
  'regular/object-group': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M500 128h-12v256h12c6.6 0 12 5.4 12 12v72c0 6.6-5.4 12-12 12h-72c-6.6 0-12-5.4-12-12v-12h-320v12c0 6.6-5.4 12-12 12h-72c-6.6 0-12-5.4-12-12v-72c0-6.6 5.4-12 12-12h12v-256h-12c-6.6 0-12-5.4-12-12v-72c0-6.6 5.4-12 12-12h72c6.6 0 12 5.4 12 12v12h320v-12c0-6.6 5.4-12 12-12h72c6.6 0 12 5.4 12 12v72c0 6.6-5.4 12-12 12zM448 64v32h32v-32h-32zM32 64v32h32v-32h-32zM64 448v-32h-32v32h32zM480 448v-32h-32v32h32zM440 384v-256h-12c-6.6 0-12-5.4-12-12v-12h-320v12c0 6.6-5.4 12-12 12h-12v256h12c6.6 0 12 5.4 12 12v12h320v-12c0-6.6 5.4-12 12-12h12zM404 192c6.6 0 12 5.4 12 12v168c0 6.6-5.4 12-12 12h-200c-6.6 0-12-5.4-12-12v-52h-84c-6.6 0-12-5.4-12-12v-168c0-6.6 5.4-12 12-12h200c6.6 0 12 5.4 12 12v52h84zM136 168v112h144v-112h-144zM376 344v-112h-56v76c0 6.6-5.4 12-12 12h-76v24h144z'
      }
    ]
  }
})
